<div class="metric-card-holder">
  <app-speed-score-card
    [loading]="loadingDesktopSpeedScore$ | async"
    [sourceData]="desktopSpeedScoreInfo$ | async"
    [refreshing]="desktopRefreshing$ | async"
    [header]="cardConfig.Desktop.header"
    [cardImage]="desktopCardImage"
    (learnButtonClicked)="learnMore()"
    (improveButtonClicked)="improveSpeed('desktop')"
    (refreshButtonClicked)="refreshScores('desktop')"
  ></app-speed-score-card>
  <app-speed-score-card
    [loading]="loadingMobileSpeedScore$ | async"
    [sourceData]="mobileSpeedScoreInfo$ | async"
    [refreshing]="mobileRefreshing$ | async"
    [header]="cardConfig.Mobile.header"
    [cardImage]="mobileCardImage"
    (learnButtonClicked)="learnMore()"
    (improveButtonClicked)="improveSpeed('mobile')"
    (refreshButtonClicked)="refreshScores('mobile')"
  ></app-speed-score-card>
</div>
